// removed by extract-text-webpack-plugin
module.exports = {"form-container":"user-settings__form-container___7ycLG","field-cell":"user-settings__field-cell___1ZRz9","fields":"user-settings__fields___Fe-Lb"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/settings/user-settings.scss
// module id = 523
// module chunks = 0